// extracted by mini-css-extract-plugin
export default {"btnWrapper":"LoginForm_btnWrapper__mp21r"};